class MiniCartButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', () => {
      document.dispatchEvent(new CustomEvent('mini-cart:open'));
    });
  }
}

if (!customElements.get("mini-cart-button")) {
  customElements.define("mini-cart-button", MiniCartButton);
}
